/* Raghu 27/10/2022 3225736869 Table UI enhancements alignment fixes
Prakash 10/31/2022 3225736869 added Table Pagination.
saikrishna 11/03/2022 3225736869 changed the paginationOptions
*/
import React, {createRef} from 'react';
// import MaterialTable, { MTableBody, MTableBodyRow } from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../../../constants/ReusableTablePagination';
import {httpPaginationPost} from './../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {fetchTaskExecutionDetails} from '../../../../../redux/reducers/NightJobs/AddNightJob';
import {useUpdateEffect} from 'react-use';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

export default function JobExecutionTable({setOpen, jobCode, setTask}) {
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Execution Id',
      field: 'jobExecutionId',
      cellStyle: {textAlign: 'center'},
    },
    {
      title: 'Job Name',
      field: 'jobCode',
      cellStyle: {textAlign: 'center'},
    },

    {
      title: 'Scheduled Time',
      field: 'scheduledTime',
      type: 'numeric',
      // cellStyle: { textAlign: "right" },
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>{rowData?.scheduledTime && moment(rowData.scheduledTime).format('MM/DD/YYYY')}</>
      ),
    },
    {
      title: 'Start Time',
      field: 'startTime',
      type: 'numeric',
      // cellStyle: { textAlign: "right" },
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>{rowData?.startTime && moment(rowData.startTime).format('MM/DD/YYYY')}</>
      ),
    },
    {
      title: 'End Time',
      field: 'endTime',
      type: 'numeric',
      // width: "2%",
      // cellStyle: { textAlign: "right" },
      dateSetting: {locale: 'en-US'},
      render: (rowData) => <>{rowData?.endTime && moment(rowData.endTime).format('MM/DD/YYYY')}</>,
    },
    {
      title: 'Execution Status',
      field: 'execStatus',
      type: 'string',
    },
    {
      title: 'Error Details',
      field: 'errorMessage',
      type: 'string',
    },
  ];

  const tableRef = createRef();
  const dispatch = useDispatch();

  useUpdateEffect(() => {
    if (tableRef?.current) {
      tableRef.current.onQueryChange();
    }
  }, [jobCode]);

  return (
    <>
      <Grid item xs={12}>
        <div
          className={`custom-table global-field-table custom-actions-icon  drag-and-drop-table custom-map-sec`}
        >
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            // data={exeTableData}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `nightJobs/getAll/jobExecution`;

                const bodyObj = {
                  limit: query.pageSize ? query.pageSize : null,
                  page: query.page ? query.page + 1 : 1,
                  orderDirection: '',
                  orderBy: '',
                  jobCode: jobCode ? jobCode : '',
                };
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObject;

                      resolve({
                        data: data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              })
            }
            textAlign="left"
            options={{
              search: false,
              toolbar: false,
              sorting: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <VisibilityOutlinedIcon/>
                  </>
                ),
                tooltip: 'View Executions',
                onClick: (e, rowData) => {
                  setOpen(true);
                  dispatch(fetchTaskExecutionDetails(rowData.jobExecutionId));
                  setTask(true);
                },
              },
            ]}
            components={{

              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                  }}
                />

              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}
